import React from 'react';
import PropTypes from 'prop-types';

import User from '../../../../../Model/User';

import NotificationSettings from './NotificationSettings';
import NutritionSettings from './NutritionSettings';
import WorkoutPreferences from './WorkoutPreferences/WorkoutPreferences';
import {
  Container,
} from './styles';

const ClientSettings = ({
  user,
  userDoc,
  coachId,
}) => (
  <Container>
    <NotificationSettings userDoc={userDoc} />
    <NutritionSettings clientId={user} coachId={coachId} />
    <WorkoutPreferences clientId={user} />
  </Container>
);

ClientSettings.propTypes = {
  user: PropTypes.string.isRequired,
  userDoc: PropTypes.instanceOf(User),
  coachId: PropTypes.string.isRequired,
};

ClientSettings.defaultProps = {
  userDoc: null,
};

export default ClientSettings;
